import { useBusinessLanguages } from '@/hooks/useBusinessLanguages';
import { useIntl } from '@/i18n';
import { toTransportLanguage } from '@/utils/language';
import { GlobalOutlined } from '@ant-design/icons';
import { Alert } from 'antd';

/**
 * 非主语言显示真实译全度；内部阅读端采用平台正式标记。
 * 语言策略读不到时 provider 已回退内置三语，这里不再显示错误提示（403 是常态）。
 */
export default function BusinessLanguageBanner() {
  const intl = useIntl();
  const { languages } = useBusinessLanguages();
  if (!languages) return null;
  const code = toTransportLanguage(intl.locale);
  if (code === languages.mainLang) return null;
  const rows = [...languages.langs, ...languages.disabledLangs];
  const current = rows.find((row) => row.code === code);
  const main = rows.find((row) => row.code === languages.mainLang);
  if (!current || !main) return null;
  const internal = current.devEnds.includes('admin');
  return (
    <Alert
      role="status"
      type="info"
      showIcon
      icon={<GlobalOutlined />}
      className="mb-3"
      title={intl.formatMessage(
        {
          id: internal
            ? 'businessLanguage.internal'
            : 'businessLanguage.coverage',
        },
        {
          language: current.name,
          main: main.name,
          coverage: current.coverage === null ? '—' : `${current.coverage}%`,
        },
      )}
    />
  );
}
